import { Outlet } from "react-router-dom";
import Header from "../Components/CommonPages/Header";

export default function Layout({ username, setUsername }) {
  return (
    <>
      <Header username={username}/>
      <Outlet context={{ setUsername }}  />
    </>
  );
}
